module.exports = __webpack_public_path__ + "static/media/ram.0aee1c4c.svg";